


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import type { Notification as notificationModel } from '@/models/notification';
import moment from 'moment';
import { notificationWebservice } from '@/webservices/notification';
import { Action, Getter } from 'vuex-class';
import type { CompanySetting } from '@/models/companySetting';

@Component({
    name: 'Notification',
    components: {},
})
export default class Notification extends Vue {
    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Getter('utils/currentLocale') private currentLocale: string;

    @Prop() private notification: notificationModel;
    private showMarker = false;

    @Action('notifications/fetchCount') private fetchNotificationCount;

    mounted() {
        this.showMarker = !this.notification.read_at;
    }

    private markOneAsRead(notification: string) {
        notificationWebservice.markAsRead([notification]).then(() => {
            // Remove read marker
            this.showMarker = false;
            this.fetchNotificationCount();
        });
    }

    get userName() {
        return `${this.notification.data.user.firstname} ${this.notification.data.user.lastname}`;
    }

    get userInitials() {
        return `${this.notification.data.user.firstname.slice(0, 1)}${this.notification.data.user.lastname.slice(
            0,
            1
        )}`;
    }

    get userIconColor() {
        const str = this.userName;
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            // tslint:disable-next-line:no-bitwise
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        let color = '#';
        for (let i = 0; i < 3; i++) {
            // tslint:disable-next-line:no-bitwise
            const value = (hash >> (i * 8)) & 0xff;
            color += ('00' + value.toString(16)).substr(-2);
        }
        return color;
    }

    get relativeDate() {
        return moment(this.notification.created_at).fromNow();
    }
}
